const searchBtn = () => {

  document.addEventListener('DOMContentLoaded', function () {
    const headerMenu = document.getElementById('Header');
    const searchBtn = document.querySelector('.search-icon');
    const closeSearch = document.querySelector('.close-search');
    const searchBlock = document.querySelector('.search-block');

    if (!headerMenu) {
      return;
    }
    searchBtn.addEventListener('click', function () {
      searchBlock.classList.add('active');
    });

    closeSearch.addEventListener('click', function () {
      searchBlock.classList.remove('active');
    });
  })
};

export default searchBtn;
